// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"ab25c4f5","693":"bdaa2b07","845":"b7f3cee7","983":"91f9471a"}[chunkId] + ".chunk.js";
};